<div class="popover" [attr.data-category]="meta().category">
  <div class="popover-row">

    <!-- Editor (type-specific) -->
    <div class="popover-editor">
      @switch (constraint().type) {

        @case (PolicyType.PARTICIPANT_RESTRICTED) {
          <div class="popover-chips-editor">
            <mat-chip-grid #chipGrid>
              @for (bpn of bpnChips(); track bpn) {
                <mat-chip-row (removed)="removeBpn(bpn)">
                  {{ bpn }}
                  <button matChipRemove aria-label="Remove">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
            </mat-chip-grid>
            <mat-form-field appearance="outline" class="popover-field popover-field--no-label">
              <input matInput
                     [formControl]="bpnInput"
                     [matChipInputFor]="chipGrid"
                     [placeholder]="'policyBuilder.editor.bpnPlaceholder' | transloco"
                     (keydown)="onBpnKeydown($event)"
                     (blur)="addBpn()" />
            </mat-form-field>
            <span class="popover-bpn-hint">
              {{ 'policyBuilder.editor.bpnHintPrefix' | transloco }}
              <span class="popover-bpn-hint-key">Enter</span>
              <span class="popover-bpn-hint-key">Tab</span>
              {{ 'policyBuilder.editor.bpnHintOr' | transloco }}
              <span class="popover-bpn-hint-key">,</span>
              {{ 'policyBuilder.editor.bpnHintSuffix' | transloco }}
            </span>
          </div>
        }

        @case (PolicyType.MEMBERSHIP_STATIC) {
          <span class="popover-static">{{ 'policyBuilder.editor.membershipInfo' | transloco }}</span>
        }

        @case (PolicyType.FRAMEWORK_AGREEMENT) {
          <span class="popover-static">{{ 'policyBuilder.editor.frameworkAgreementInfo' | transloco }}</span>
        }

        @case (PolicyType.USE_CASE_MEMBERSHIP) {
          <mat-form-field appearance="outline" class="popover-field popover-field--no-label">
            <mat-select [formControl]="useCaseCtrl"
                        [placeholder]="'policyBuilder.editor.useCaseLabel' | transloco">
              @for (opt of useCaseOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label | transloco }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @case (PolicyType.TIME_PERIOD_RESTRICTED) {
          <mat-form-field appearance="outline" class="popover-field popover-field--no-label">
            <input matInput type="number" [formControl]="countCtrl" min="1"
                   [placeholder]="'policyBuilder.editor.durationLabel' | transloco" />
            <span matTextSuffix class="popover-suffix">{{ 'policyBuilder.editor.durationSuffix' | transloco }}</span>
          </mat-form-field>
        }

        @case (PolicyType.END_DATE) {
          <mat-form-field appearance="outline" class="popover-field popover-field--no-label">
            <input matInput [matDatepicker]="picker" [formControl]="endDateCtrl" [min]="minDate"
                   [placeholder]="'policyBuilder.editor.endDateLabel' | transloco" />
            <mat-datepicker-toggle matIconSuffix [for]="picker" />
            <mat-datepicker #picker />
          </mat-form-field>
        }

        @case (PolicyType.COMPANY_REGION_RESTRICTED) {
          <mat-form-field appearance="outline" class="popover-field popover-field--no-label">
            <mat-select [formControl]="regionCtrl"
                        [placeholder]="'policyBuilder.editor.companyRegionLabel' | transloco">
              @for (opt of regionOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label | transloco }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @case (PolicyType.DATACENTER_REGION_RESTRICTED) {
          <mat-form-field appearance="outline" class="popover-field popover-field--no-label">
            <mat-select [formControl]="regionCtrl"
                        [placeholder]="'policyBuilder.editor.datacenterRegionLabel' | transloco">
              @for (opt of regionOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label | transloco }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }
    </div>

    <!-- Action buttons: check / close -->
    <div class="popover-actions">
      <button class="popover-action popover-action--apply"
              [disabled]="!isValid()"
              (click)="apply()"
              aria-label="Apply">
        <mat-icon>check</mat-icon>
      </button>
      <button class="popover-action popover-action--cancel"
              (click)="cancel()"
              aria-label="Cancel">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
